import styled from 'styled-components';
import { mediumUp, largeUp, xLargeUp } from '../../../styles/breakpoints';

export const LayoutBreakpoints = styled.div`
    margin: 0 16px;

    ${mediumUp} {
        margin: 0 auto;
        max-width: 720px;
    }

    ${largeUp} {
        max-width: 940px;
    }

    ${xLargeUp} {
        max-width: 1140px;
    }
`;
